import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const styles = theme => ({
    hintSummary: {
        transition: 'all 0.2s ease-out',
        '&:hover': {
            color: '#ef5285'
        }
    },
    hintDetails: {
        color: '#999999'
    },
    expansionPanel: {
        background: '#424242',
        color: '#f4f4f4'
    }
});

class SingleHint extends React.Component {

    constructor(props) {
        super(props);
        this.state = { expanded: false };
    }

    handleChange(expanded) {
        this.setState({expanded});
    }

    render() {
        const { classes, content } = this.props;
        const { expanded } = this.state;

        return (
            <ExpansionPanel
                onChange={(event, expanded) => this.handleChange(expanded)}
                className={classes.expansionPanel}
            >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.hintSummary}>
                    Click to {expanded ? 'hide' : 'show'} hint
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.hintDetails}>
                    {content}
                </ExpansionPanelDetails>
            </ExpansionPanel>
        );
    }

}

SingleHint.propTypes = {
    classes: PropTypes.object.isRequired,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired
};

export default withStyles(styles)(SingleHint);